import { useParams } from 'react-router-dom'
import { PlansOrgView } from '@/features/plans/PlansOrgView'

// ── Top-level page ────────────────────────────────────────────────────────────

export function PlansPage() {
  const { orgSlug, workspace: workspaceParam, versionId } = useParams<{ orgSlug?: string; workspace?: string; versionId?: string }>()
  if (!orgSlug) return null
  return <PlansOrgView orgSlug={orgSlug} workspaceParam={workspaceParam} defaultVersionId={versionId} />
}
